
import { MailIcon } from "lucide-react";
import { FaInstagram, FaWhatsapp, FaFacebook } from 'react-icons/fa';
import { CONTACT, NAV_LINKS } from "../lib/data";

export const Footer = () => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <footer data-testid="site-footer" className="relative border-t border-white/5 py-14 bg-[#040814]">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-2 mb-4">
                            <img src="/logo.png" alt="RS Web Studio logo" className="h-10 w-auto" />
                            {/* <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 to-blue-600 flex items-center justify-center font-black text-[#040814]">
                                R
                            </div>
                            <span className="font-bold text-lg">
                                RS Digital <span className="text-cyan-400">Studio</span>
                            </span> */}
                        </div>
                        <p className="text-slate-400 max-w-md leading-relaxed text-[15px]">
                            A one-developer web studio crafting fast, beautiful websites for small local
                            businesses worldwide.
                        </p>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-4">
                            Navigate
                        </div>
                        <ul className="space-y-2.5">
                            {NAV_LINKS.slice(0, 6).map((l) => (
                                <li key={l.id}>
                                    <button
                                        data-testid={`footer-nav-${l.id}`}
                                        onClick={() => scrollTo(l.id)}
                                        className="text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                    >
                                        {l.label}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold mb-4">
                            Connect
                        </div>
                        <ul className="space-y-2.5">
                            {/* <li>
                                <a
                                    data-testid="footer-linkedin"
                                    href="https://www.linkedin.com/company/rsdwebstudio/?viewAsMember=true"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                >
                                    <FaLinkedin size={14} /> LinkedIn
                                </a>
                            </li> */}
                            <li>
                                <a
                                    data-testid="footer-instagram"
                                    href="https://www.instagram.com/rsdwebstudio/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                >
                                    <FaInstagram size={14} /> Instagram
                                </a>
                            </li>
                            <li>
                                <a
                                    data-testid="footer-facebook"
                                    href="https://www.facebook.com/rsdwebstudio/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                >
                                    <FaFacebook size={14} /> Facebook
                                </a>
                            </li>
                            <li>
                                <a
                                    data-testid="footer-whatsapp"
                                    href={`https://wa.me/${CONTACT.whatsapp}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                >
                                    <FaWhatsapp size={14} /> WhatsApp
                                </a>
                            </li>
                            <li>
                                <a
                                    data-testid="footer-email"
                                    href={`mailto:${CONTACT.email}`}
                                    className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                >
                                    <MailIcon size={14} /> Email
                                </a>
                            </li>
                            {/* <li>
                                <a
                                    data-testid="footer-portfolio"
                                    href="https://rsachindev.vercel.app"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors text-sm"
                                >
                                    <Link size={14} /> Personal site
                                </a>
                            </li> */}

                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-white/5 flex flex-wrap items-center justify-between gap-3 text-sm text-slate-500">
                    <div>© {new Date().getFullYear()} RS Digital Web Studio. Crafted with care by Sachin.</div>
                    <div className="text-xs uppercase tracking-[0.2em]">Built in India · Shipped worldwide</div>
                </div>
            </div>
        </footer>
    );
};
